import { Box, Paper, Skeleton, Stack, Typography } from "@mui/material";
import { PieChartItem, SimplePieChart } from "../../../../../../../components/charts/graph/SimplePieChart";

interface AbsoluteBreakDownProps {
	title: string;
	pieChartData: PieChartItem[];
	isLoading: boolean;
}

export const AbsoluteBreakDown = ({ title, pieChartData, isLoading }: AbsoluteBreakDownProps) => {
	if (isLoading) {
		return (
			<Paper sx={{ flex: 1 }} elevation={0}>
				<Skeleton variant="rounded" height={200} width="100%" />
			</Paper>
		);
	}
	return (
		<Paper elevation={0} sx={{ p: 2 }}>
			<Stack gap={1}>
				<Typography variant="h6" color="primary">
					{title}
				</Typography>
				<Stack width={"100%"} alignItems={"center"}>
					<Box maxWidth={500}>
						<SimplePieChart data={pieChartData} />
					</Box>
				</Stack>
			</Stack>
		</Paper>
	);
};
